module.exports = __webpack_public_path__ + "static/media/scanopro-4.647d6f4c.jpg";